import { Service } from "typedi";
import { Repository } from "./repository";

@Service()
export class LanguageRepository extends Repository<string> {
    clazz = undefined
    key = "language"
}
